import Styles from "./MobileAboutMe.module.scss";
import { ReactComponent as DiscoverIcon } from "../../../icons/extra_icons/samsung_discover.svg"
import BixbyIcon from "../../../icons/extra_icons/samsung_bixby.gif"

//Redux
import { closeWindow } from "../../../actions";
import { useDispatch } from "react-redux";
import { APP_KEY_IDS } from "../../../constants/constants";

const MobileAboutMe = () => {
  
  const dispatch = useDispatch()
  
  return (
    <div className={Styles.container} onClick={()=>{dispatch(closeWindow(APP_KEY_IDS.MOBILE_BIXBY))}}>
      <div className={Styles.bixby_box} onClick={(e:any)=>{e.stopPropagation()}}>
        <div className={Styles.top_bar}>
          <DiscoverIcon />
          Discover
        </div>
        <div className={Styles.base_command} id="cmd">
          About Priyansh Datyal
        </div>

        <div className={Styles.result} id="cmd">
          Hello World
          <br />Welcome to my portfolio
          <br />This is Priyansh Datyal
          <br />DOB : Jun-2001
          <br />Computer Science Engineer 2018-2022
          <br />Professional Experience : 1yr 3months
          <br />Origin : Himachal Pradesh
          <br />
        </div>
        <div className={Styles.bottom_bar}>
          <img src={BixbyIcon}/>
        </div>
      </div>
      
    </div>
  )
}

export default MobileAboutMe
